// MUI components
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import CustomButton from 'components/Button/CustomButton';

export const RecordVideoButton = styled(CustomButton)(() => ({
  borderRadius: '6px',
  padding: '10px 12px',
  height: 44,

  fontWeight: 600,
  fontSize: 14,
  lineHeight: '100%',
  letterSpacing: 0,
}));

export const UploadingVideoContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: 80,
  width: 80,
  borderRadius: 12,
  backgroundColor: 'rgba(235, 234, 255, 1)',
  position: 'relative',
  '& .closeIconCnt': {
    position: 'absolute',
    zIndex: 1000,
  },
}));

export const VideosContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 10,
  gap: 12,
  cursor: 'pointer',
  flexWrap: 'wrap',
  '& .videoItem': {
    width: 80,
    height: 80,
    borderRadius: 12,
    backgroundColor: 'rgba(235, 234, 255, 1)',
    position: 'relative',

    '& .removeIconCnt': {
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 1000,
      display: 'none',
      '& .removeIcon': {
        color: '#a52424',
      },
    },
    '&: hover': {
      '& .removeIconCnt': {
        display: 'block',
      },
    },

    '& .playBtnCnt': {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',

      '& svg': {
        color: 'white',
        height: 30,
        width: 30,
      },
      '& svg path:first-of-type': {
        color: 'white', // Outer circle
      },
      '& svg path:last-of-type': {
        color: 'white', // Play button
      },
    },
    '& video': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 12,
    },
  },
}));
